export enum PermissionTypeEnum {
	READ = 'read',
	CREATE = 'create',
	UPDATE = 'update',
	DELETE = 'delete',
	NONE = 'none',
	ALL = 'all'
}